import React from "react"
import cn from "classnames"

import styles from "./VNConcessionsNavBar.module.scss"
import BackButtonChevron from "./BackButtonChevron"
import NetworkIndicator from "../containers/NetworkIndicator"

const VNConcessionsNavBar = ({
  textDisplay = "",
  onClick = () => {},
  alternateIcon,
  showIcon = true,
  className,
}) => {
  const classNames = cn(styles.vnConcessionsNavBar, className)
  const isMobileViewPort = window?.matchMedia("(max-width: 500px)").matches

  return (
    <section className={classNames}>
      <div
        className={styles.icon}
        onClick={() => {
          if (showIcon) onClick()
        }}
      >
        {showIcon &&
          (alternateIcon ?? (
            <BackButtonChevron
              backButtonText={isMobileViewPort ? null : "Go Back"}
            />
          ))}
      </div>
      <span className={styles.mobileHeaderText}>{textDisplay}</span>
      <NetworkIndicator />
    </section>
  )
}

export default VNConcessionsNavBar
